<template>
  <div class="align-middle text-center text-nowrap">
    <!-- Edit Button: Uses the lime/green from your Add Branch button -->
    <button class="btn btn-link text-edit px-3 mb-0" @click="$emit('edit')">
      <i class="fas fa-pencil-alt me-2"></i>EDIT
    </button>
    
    <!-- Delete Button: Uses Red -->
    <button class="btn btn-link text-danger px-3 mb-0" @click="$emit('delete')">
      <i class="far fa-trash-alt me-2"></i>DELETE
    </button>
  </div>
</template>

<script>
export default {
  name: "TableActions",
  emits: ['edit', 'delete']
};
</script>

<style scoped>
.text-edit {
  color: #8edb1c !important; /* The Add Branch Green Color */
  font-weight: bold;
}
.text-danger {
  color: #ea0606 !important;
  font-weight: bold;
}
.btn-link {
  text-decoration: none;
  font-size: 0.7rem;
}
.btn-link:hover {
  opacity: 0.7;
}
</style>